import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";
import { applyGradientStyle } from "../utils/gradientText";

function About() {
  const [scrollOffset, setScrollOffset] = useState(0);
  const sectionRef = useRef(null);
  const { language } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calculate when section is centered in viewport
        const sectionCenter = rect.top + rect.height / 2;
        const viewportCenter = windowHeight / 2;

        // Calculate distance from viewport center in pixels
        const distanceFromCenter = sectionCenter - viewportCenter;

        // Define the "center zone" (±100px)
        const centerZone = 100;

        let offset = 0;

        // If within center zone, rotation = 0
        if (Math.abs(distanceFromCenter) <= centerZone) {
          offset = 0;
        } else {
          // Outside center zone, calculate rotation proportionally
          // Calculate how far outside the zone we are
          const distanceOutsideZone = Math.abs(distanceFromCenter) - centerZone;
          // Max distance to consider (from center zone edge to full rotation)
          const maxDistance = windowHeight - centerZone;
          // Normalize the distance (0 to 1)
          const normalizedDistance = Math.min(
            1,
            distanceOutsideZone / maxDistance
          );

          // Apply rotation with direction
          offset = normalizedDistance * 180 * Math.sign(distanceFromCenter);
        }

        setScrollOffset(offset);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div
        className="about-section-bg"
        style={{ backgroundImage: "url(/assets/image.png)" }}
        aria-hidden="true"
      />
      <div className="container">
        <div className="section-header">
          <span className="section-badge">
            {translate("aboutBadge", language)}
          </span>
          <h2 className="section-title">{translate("aboutTitle", language)}</h2>
          {/* <h3 className="section-subtitle">
            {translate("aboutSubtitle", language)}
          </h3> */}
          <p className="section-description">
            {translate("aboutIntro", language, {
              company: (
                <span className="gradient-text about-company-text">
                  <span className="gradient-text-y">Y</span>GALA
                  <span className="gradient-text-accent">AD</span>
                </span>
              ),
            })}
          </p>
        </div>
        <div className="about-content">
          <div className="about-text">
            {/* <p className="about-intro">
              {(() => {
                const text = translate("aboutIntro", language, {
                  company: "YGALAAD",
                });
                const parts = text.split("{company}");
                const result = [];
                parts.forEach((part, i) => {
                  result.push(
                    <React.Fragment key={`part-${i}`}>{part}</React.Fragment>
                  );
                  if (i < parts.length - 1) {
                    result.push(
                      <strong key={`company-${i}`}>
                        <span className="logo-y">Y</span>GALA
                        <span className="logo-accent">AD</span>
                      </strong>
                    );
                  }
                });
                return result;
              })()}
            </p> */}
            <div className="about-grid">
              <div className="about-card">
                <div
                  className="card-icon parallax-icon"
                  style={{ transform: `rotate(${scrollOffset}deg)` }}
                >
                  🧠
                </div>
                <h3>{applyGradientStyle(translate("expertise", language))}</h3>
                <p>{translate("expertiseDesc", language)}</p>
              </div>
              <div className="about-card">
                <div
                  className="card-icon parallax-icon"
                  style={{ transform: `rotate(${-scrollOffset}deg)` }}
                >
                  ⚡
                </div>
                <h3>{applyGradientStyle(translate("innovation", language))}</h3>
                <p>{translate("innovationDesc", language)}</p>
              </div>
              <div className="about-card">
                <div
                  className="card-icon parallax-icon"
                  style={{ transform: `rotate(${scrollOffset}deg)` }}
                >
                  🌐
                </div>
                <h3>{applyGradientStyle(translate("mission", language))}</h3>
                <p>{translate("missionDesc", language)}</p>
              </div>
              <div className="about-card">
                <div
                  className="card-icon parallax-icon"
                  style={{ transform: `rotate(${-scrollOffset}deg)` }}
                >
                  🛠️
                </div>
                <h3>{applyGradientStyle(translate("solutions", language))}</h3>
                <p>{translate("solutionsDesc", language)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
